import clsx from 'clsx'
import React, { Children } from 'react'

import styles from './SectionToggler.module.sass'

export function SectionToggler(props: { children: React.ReactNode; headings: string[] }) {
	const [activeIndex, setActiveIndex] = React.useState(0)

	return (
		<div className={styles.wrapper}>
			<div className={styles.nav}>
				{props.headings.map((heading, index) => (
					<button
						className={clsx(styles.heading, activeIndex === index && styles.active)}
						key={index}
						onClick={() => {
							setActiveIndex(index)
						}}>
						{heading}
					</button>
				))}
			</div>
			<div className={styles.inner}>
				{Children.map(Children.toArray(props.children), (child, index) => (
					<div className={clsx(styles.item, activeIndex === index && styles.active)}>{child}</div>
				))}
			</div>
		</div>
	)
}
